import React, { useState } from "react";
import { User } from "./User";
import { useForm } from "react-hook-form";
import {
  passwordRule,
  validatePassword,
} from "../../supportFunctions/ValidationHelpers";
import { Card, Input } from "@velocity-ehs/component-library";
import classNames from "classnames/bind";
import classes from "./ChangePassword.module.scss";
import { useTranslation } from "react-i18next";

interface Props {
  onSave: (values: any) => void;
}
export type SetPasswordProps = {
  password: string;
  repeatPassword: string;
};

const ChangePassword: React.FC<Props> = (props) => {
  const cx = classNames.bind(classes);
  const { t } = useTranslation();

  const {
    control,
    handleSubmit,
    getValues,
    formState: { errors },
  } = useForm<User>({
    mode: "onBlur",
  });

  const [validationResult, setValidationResult] = useState({
    hasValidLength: false,
    hasNumber: false,
    hasUpperCase: false,
    hasLowerCase: false,
    match: false,
    hasSpecialCharacter: false,
  });

  const passwordRequirement = (
    <div className={classes.dataField}>
      <p>{t("message_passwords_must_have_at_least")}</p>
      <div className={classes.dataFieldValue}>
        <ul className={cx(classes.bulletedList, classes.passwordReq)}>
          <li className={cx({ passwordReqMet: validationResult.hasUpperCase })}>
            {t("userManagement_ChangePassword_one_uppercase")}
          </li>
          <li className={cx({ passwordReqMet: validationResult.hasLowerCase })}>
            {t("userManagement_ChangePassword_one_lowercase")}
          </li>
          <li className={cx({ passwordReqMet: validationResult.hasNumber })}>
            {t("userManagement_ChangePassword_one_number")}
          </li>
          <li
            className={cx({
              passwordReqMet: validationResult.hasSpecialCharacter,
            })}
          >
            {t("userManagement_ChangePassword_one_special_character")}
          </li>
          <li
            className={cx({ passwordReqMet: validationResult.hasValidLength })}
          >
            {t("userManagement_ChangePassword_eight_characters")}
          </li>
        </ul>
      </div>
    </div>
  );

  const changePassword = (
    <>
      <p className={classes.instruction}>{t("change_Password_Text")}</p>
      {passwordRequirement}
      <Input
        type="password"
        label={t("change_Password_Old_Password_label")}
        control={control}
        name="password"
        rules={{
          required: t("change_Password_Old_Password_text"),
          maxLength: {
            value: 32,
            message: t("change_Password_Max_Length_Validation"),
          },
        }}
        errorMessage={errors && errors.password?.message}
      />
      <Input
        type="password"
        label={t("change_Password_New_Password_label")}
        control={control}
        name="newPassword"
        rules={{
          validate: (value: any) => {
            setValidationResult(
              validatePassword(value, getValues("repeatPassword"))
            );
            return passwordRule(value, getValues("repeatPassword"));
          },
          required: t("change_Password_New_Password_text"),
          maxLength: {
            value: 32,
            message: t("change_Password_Max_Length_Validation"),
          },
        }}
        errorMessage={errors && errors.newPassword?.message}
      />
      <Input
        type="password"
        label={t("profile_repeat_password_text")}
        control={control}
        name="repeatPassword"
        rules={{
          validate: (value: any) => {
            var validateResult = validatePassword(
              getValues("newPassword"),
              value
            );
            setValidationResult(
              validatePassword(getValues("newPassword"), value)
            );
            return !value === true
              ? true
              : value.length > 0 && validateResult.match
              ? true
              : t("userManagement_ChangePassword_passwords_do_not_match");
          },
          maxLength: {
            value: 32,
            message: t("change_Password_Max_Length_Validation"),
          },
        }}
        errorMessage={errors && errors.repeatPassword?.message}
      />
    </>
  );

  const card = (
    <Card title={t("profile_Change_Password")}>
      <form id="modify-profile-form" onSubmit={handleSubmit(props.onSave)}>
        {changePassword}
      </form>
    </Card>
  );

  return card;
};

export default ChangePassword;
